import { createContext, useContext, useState, useCallback } from "react";

const EnquiryContext = createContext();

export const EnquiryProvider = ({ children }) => {
  const [readEnquiries, setReadEnquiries] = useState(new Set());

  const markAsRead = useCallback((enquiryId) => {
    setReadEnquiries((prev) => new Set([...prev, enquiryId]));
  }, []);

  const markMultipleAsRead = useCallback((enquiryIds) => {
    setReadEnquiries((prev) => new Set([...prev, ...enquiryIds]));
  }, []);

  const clearReadStatus = useCallback(() => {
    setReadEnquiries(new Set());
  }, []);

  const isRead = useCallback((enquiryId) => {
    return readEnquiries.has(enquiryId);
  }, [readEnquiries]);

  return (
    <EnquiryContext.Provider
      value={{
        readEnquiries,
        markAsRead,
        markMultipleAsRead,
        clearReadStatus,
        isRead,
      }}
    >
      {children}
    </EnquiryContext.Provider>
  );
};

export const useEnquiryContext = () => {
  const context = useContext(EnquiryContext);
  if (!context) {
    throw new Error("useEnquiryContext must be used within EnquiryProvider");
  }
  return context;
};
